import { render, staticRenderFns } from "./VSelectPreview.vue?vue&type=template&id=4c12f2eb&"
import script from "./VSelectPreview.vue?vue&type=script&lang=js&"
export * from "./VSelectPreview.vue?vue&type=script&lang=js&"
import style0 from "./VSelectPreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports